import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import ShopLayout from '../../components/shop/ShopLayout';
import api from '../../services/api';
import './AuthForm.css';
import Seo from '../../components/seo/Seo';

function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const tokenFromUrl = searchParams.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password !== confirm) {
      setError('Passwords do not match');
      return;
    }
    if (!tokenFromUrl) {
      setError('Invalid reset link');
      return;
    }
    setLoading(true);
    try {
      await api.resetPassword(tokenFromUrl, password);
      navigate('/login', { state: { message: 'Password reset successful. Please sign in.' } });
    } catch (err) {
      setError(err.message || 'Reset failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <ShopLayout breadcrumbs={[{ label: 'Reset Password' }]}>
      <Seo title="Reset Password" path="/reset-password" />
      <div className="container auth-page">
        <div className="auth-card">
          <h1>Reset Password</h1>
          <p className="auth-card__subtitle">Enter your new password below.</p>
          <form className="auth-form" onSubmit={handleSubmit}>
            {error && <div className="auth-form__error">{error}</div>}
            <div className="auth-form__field">
              <label htmlFor="password">New Password</label>
              <input id="password" type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} />
            </div>
            <div className="auth-form__field">
              <label htmlFor="confirm">Confirm Password</label>
              <input id="confirm" type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} />
            </div>
            <button type="submit" className="auth-form__submit" disabled={loading}>
              {loading ? 'Updating…' : 'Reset Password'}
            </button>
          </form>
          <div className="auth-card__footer">
            <p><Link to="/login">Back to sign in</Link></p>
          </div>
        </div>
      </div>
    </ShopLayout>
  );
}

export default ResetPasswordPage;
